import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import { LogoField } from "./LogoField";

/**
 * The fields of the sport form, shared by Add Sport and Update Sport (#306), as AuctionFormFields is
 * for the auction forms. Update used to be laid out on its own - no labels, one column, no file hint
 * - so the two looked like different forms. The screen owns the <Form>, its validation and buttons.
 *
 * @param {object} props
 * @param {string} props.idPrefix Makes the controlIds unique, so each label is tied to its input.
 * @param {{sportName?: string}} props.values The form's values.
 * @param {(event: object) => void} props.onChange Called with the name input's change event.
 * @param {boolean} [props.nameTooLong] Shows the 50-character note under the name.
 * @param {object} props.image The form's useImageUpload.
 * @param {string} [props.placeholderImage] The logo shown while the sport has none.
 */
export const SportFormFields = ({ idPrefix, values, onChange, nameTooLong, image, placeholderImage }) => (
  <Row className="mb-3">
    <Form.Group as={Col} md="6" controlId={`${idPrefix}-name`}>
      <Form.Label>Sport Name</Form.Label>
      <Form.Control
        required
        type="text"
        name="sportName"
        maxLength={50}
        value={values?.sportName ?? ""}
        onChange={onChange}
        placeholder="Sport Name"
      />
      <Form.Control.Feedback type="invalid">Please enter valid sport name.</Form.Control.Feedback>
      {nameTooLong && <p style={{ color: "#dc3545" }}>Sport shouldn't exceed 50 characters</p>}
    </Form.Group>

    <Form.Group as={Col} md="6" controlId={`${idPrefix}-logo`}>
      <LogoField name="sportImage" image={image} placeholder={placeholderImage} />
    </Form.Group>
  </Row>
);
